import store from '@/store'
import { httpHelper } from '@/utils'

export const commonService = {
    populateData,
    populateUsers,
}

function populateData() {
    const requests = [
        fetchAssetTypes().then(value => {
            store.state.tracker.assetTypes = value
        }),
        fetchLocations().then(value => {
            store.state.location.locations = value
        }),
        fetchTrackers().then(value => {
            store.state.tracker.trackers = value
            if (store.getters['auth/isAxRoad']) {
                store.dispatch('tracker/updateTrailers')
            }
        }),
    ]

    store.dispatch('preferences/fetchPreferences')

    if (store.getters['auth/hasLsvaAccess']) {
        requests.push(store.dispatch('lsva/fetchAllTrucks'))
    }

    if (
        store.getters['auth/isAdminOrStaff'] ||
        store.getters['auth/isSimulationMode']
    ) {
        requests.push(
            fetchUsers().then(value => {
                store.state.user.users = value
            }),
            fetchRoles().then(value => {
                store.state.role.roles = value
            })
        )
    } else {
        store.state.user.users = []
        store.state.user.roles = []
    }

    if (store.getters['auth/hasMaintenanceAccess']) {
        requests.push(
            fetchMaintenancePolicies().then(value => {
                store.state.maintenance.maintenancePolicies = value
            })
        )
    } else {
        store.state.maintenance.maintenancePolicies = []
    }

    if (store.getters['auth/isAxRoad']) {
        if (store.getters['auth/hasTachographAccess']) {
            requests.push(
                fetchDrivers().then(value => {
                    store.state.tracker.drivers = value
                })
            )
        }
        // TODO: maybe use another flag for warnings
        if (store.getters['auth/hasRulesAccess']) {
            requests.push(
                fetchWarnings().then(value => {
                    store.state.warnings.allWarnings = value
                    store.state.warnings.warnings = value.filter(
                        warning => !warning.resolved
                    )
                })
            )
        }
    }

    return Promise.all(requests)
}

async function populateUsers() {
    if (
        store.getters['auth/isAdminOrStaff'] ||
        store.getters['auth/isSimulationMode']
    ) {
        store.state.user.users = await fetchUsers()
    }
}

async function fetchAssetTypes() {
    const { data } = await httpHelper.get('/assettypes/')
    return data.results
}

async function fetchLocations() {
    const { data } = await httpHelper.getRecursively('/locations/', {
        params: {
            limit: process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST,
        },
    })
    return data.results
}

async function fetchMaintenancePolicies() {
    const { data } = await httpHelper.getRecursively('/maintenance-policies/', {
        params: {
            limit: process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST,
        },
    })
    return data.results
}

async function fetchTrackers() {
    const { data } = await httpHelper.getRecursively('/trackers/', {
        params: {
            limit: process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST,
        },
    })
    return data.results
}

async function fetchUsers() {
    const { data } = await httpHelper.getRecursively('/users/', {
        ...(await httpHelper.getOverwrittenConfig()),
        params: {
            limit: process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST,
        },
    })
    return data.results
}

async function fetchRoles() {
    const { data } = await httpHelper.getRecursively('/roles/', {
        ...(await httpHelper.getOverwrittenConfig()),
        params: {
            limit: process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST,
        },
    })
    return data.results
}

async function fetchDrivers() {
    const { data } = await httpHelper.getRecursively('/tachograph/drivers/', {
        params: {
            limit: process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST,
        },
    })
    return data.results
}

async function fetchWarnings() {
    const { data } = await httpHelper.getRecursively(
        '/alertrule-notifications/',
        {
            params: {
                limit: process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST,
            },
        }
    )
    return data.results
}
